<miq-filter-bar-label *ngIf="!hideTitle" [props]="props"></miq-filter-bar-label>

<div class="simpleselect_dropdown" *ngIf="!multi">
  <mat-form-field appearance="outline">
    <mat-select
      hideSingleSelectionIndicator="true"
      disableOptionCentering
      panelClass="select-drop-panel"
      [placeholder]="props.placeholder || ('shared.select' | xTranslate)"
      [formControl]="mainValueControl"
      (selectionChange)="onSelectionChanged($event)"
    >
      <!--Custom Search -->
      <ng-container *ngIf="props.hasFilter">
        <ng-container
          *ngTemplateOutlet="
            simpleSelectCustomSearch;
            context: {
              optionsFilterControl: optionsFilterControl,
              filteredOptions: filteredOptions | async,
            }
          "
        ></ng-container>
      </ng-container>

      <ng-container *ngFor="let option of filteredOptions | async">
        <mat-option [value]="option[dataKey]">
          <!-- translation required -->
          <ng-container *ngIf="props.translateOptionsRequired; else untranslatedOption">
            {{ option.value || option.key || '-' | xTranslate | uppercase }}
          </ng-container>
          <!-- translation NOT required -->
          <ng-template #untranslatedOption>
            {{ option.value || option.key || '-' | uppercase }}
          </ng-template>
        </mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>
</div>
<div class="simpleselect_dropdown" *ngIf="multi">
  <mat-form-field appearance="outline">
    <mat-select
      hideSingleSelectionIndicator="true"
      disableOptionCentering
      panelClass="select-multiple-drop-panel"
      [formControl]="mainValueControl"
      [placeholder]="props.placeholder || ('shared.select' | xTranslate)"
      (selectionChange)="onSelectionChanged($event)"
      (openedChange)="openedChange($event)"
      multiple
    >
      <!--Custom Search -->
      <ng-container *ngIf="props.hasFilter">
        <ng-container
          *ngTemplateOutlet="
            simpleSelectCustomSearch;
            context: {
              optionsFilterControl: optionsFilterControl,
              filteredOptions: filteredOptions | async,
            }
          "
        ></ng-container>
      </ng-container>

      <!-- Display allKey value if all opt is selected -->
      <mat-select-trigger *ngIf="props.allKey && isAllSelected">
        {{ props.allKey }}
      </mat-select-trigger>
      <!-- Show if allKey is present -->
      <mat-option
        *ngIf="props.allKey && filteredOptions | async"
        class="checkbox-customization"
        [value]="props.allKey"
        >{{ props.allKey }}</mat-option
      >

      <ng-container *ngFor="let option of filteredOptions | async">
        <mat-option
          class="checkbox-customization"
          [value]="option[dataKey]"
          (onSelectionChange)="onOptionSelected($event)"
        >
          <!-- translation required -->
          <ng-container *ngIf="props.translateOptionsRequired; else untranslatedOption">
            {{ (option.value || option.key | xTranslate | uppercase) || '-' }}
          </ng-container>
          <!-- translation NOT required -->
          <ng-template #untranslatedOption>
            {{ (option.value || option.key | uppercase) || '-' }}
          </ng-template>
        </mat-option>
      </ng-container>
    </mat-select>
    <em
      *ngIf="displayClearButton && (mainValueControl?.value || mainValueControl?.value?.length)"
      class="multiselect-clear pi pi-times-circle"
      (click)="clearFilter()"
    ></em>
  </mat-form-field>
</div>

<!-- Custom Input Search -->
<ng-template
  #simpleSelectCustomSearch
  let-optionsFilterControl="optionsFilterControl"
  let-filteredOptions="filteredOptions"
>
  <div class="ss-search-box-container">
    <input
      #searchInput
      [formControl]="optionsFilterControl"
      type="text"
      autocomplete="no-autofill"
      [placeholderLabel]="'shared.find' | xTranslate"
      class="ss-search-box-container-input"
    />
    <mat-icon *ngIf="optionsFilterControl?.value?.length > 0" class="ss-search-box-clear" (click)="clearSearchBox()"
      >close</mat-icon
    >
  </div>

  <!-- When searching and there are no matches-->
  <mat-option *ngIf="filteredOptions?.length === 0" disabled class="ss-no-matches checkbox-customization">
    {{ 'shared.noMatchFound' | xTranslate }}
  </mat-option>
</ng-template>
